import { API } from "aws-amplify";
import globalOptions from "./apiReqOptions";
import { checkForAuthError, responseData } from "./RequestLib";

const options = Object.assign(
  {
    response: true,
  },
  globalOptions
);

export async function get(objType, obj_id, apiName = "app-api") {
  let obj = {
    type: objType,
    id: obj_id,
  };
  try {
    let response = await API.get(
      apiName,
      `/app-api/${JSON.stringify(obj)}`,
      options
    );
    return responseData(response);
  } catch (err) {
    checkForAuthError(err);
  }
}

export async function getList(objType, company, params, apiName = "app-api") {
  let obj = {
    type: objType,
    activeCompanyId: company.id,
  };
  if (params) {
    obj = { ...obj, ...params };
  }
  try {
    let response = await API.get(
      apiName,
      `/${apiName}/list/${JSON.stringify(obj)}`,
      options
    );
    return responseData(response);
  } catch (err) {
    checkForAuthError(err);
  }
}

export async function create(objType, obj, apiName = "app-api") {
  let body = {
    content: obj,
    type: objType,
  };
  try {
    let response = await API.post(
      apiName,
      `/${apiName}`,
      {
        body: body,
      },
      options
    );
    return responseData(response);
  } catch (err) {
    checkForAuthError(err);
  }
}

export async function update(objType, obj, companyId, apiName = "app-api") {
  let path = {
    id: obj.id,
  };
  let body = {
    content: obj,
    type: objType,
  };
  obj.type = objType;
  let b = {
    body: body,
  };
  if (companyId) {
    b.activeCompanyId = companyId;
  }
  try {
    let response = await API.put(
      apiName,
      `/${apiName}/${JSON.stringify(path)}`,
      b,
      options
    );
    return responseData(response);
  } catch (err) {
    checkForAuthError(err);
  }
}

export async function delObj(
  objType,
  obj_id,
  companyId,
  data,
  apiName = "app-api"
) {
  let params = {
    type: objType,
    id: obj_id,
  };
  if (companyId) {
    params.activeCompanyId = companyId;
  }
  if (data) {
    params = Object.assign(params, data);
  }
  try {
    let response = await API.del(
      apiName,
      `/${apiName}/${JSON.stringify(params)}`,
      options
    );
    return responseData(response);
  } catch (err) {
    checkForAuthError(err);
  }
}

// function responseData(response) {
//   let data = response;

//   if ("data" in response && response.data) {
//     data = response.data;
//   }

//   if (
//     "headers" in response &&
//     response.headers &&
//     response.headers["x-taabl-metadata-last-key"]
//   ) {
//     data.lastKey = response.headers["x-taabl-metadata-last-key"];
//   }

//   return data;
// }

export function upload(url, file) {
  return API.put();
}

export function signupVerification(emailAddress) {
  return API.get("taabl-api", `/signupverification/${emailAddress}`);
}

// function checkForAuthError(err) {
//   console.log(err);
//   if (
//     err &&
//     err.response &&
//     err.response.data &&
//     err.response.data.message &&
//     typeof err.response.data.message === "string" &&
//     err.response.data.message === "Missing Authentication Token"
//   ) {
//     window.location.href = "/login";
//     return;
//   }
//   throw err;
// }
